import en from './en'
import it from './it'
import fr from './fr'
import de from './de'
import es from './es'

/** Dizionari di traduzione per ogni lingua supportata. */
export const messages = { en, it, fr, de, es }
